import * as Yup from 'yup';

const charRegex = /^(?=.*[a-zA-Z_])[a-zA-Z0-9_\s]+$/;
export const updateValidationSchema = Yup.object({
  Loc_Name: Yup.string()
    .trim()
    .required('Location name is required')
    .max(25, 'Maximum 25 characters allowed')
    .matches(
      charRegex,
      'Location name must contain at least one letter and can include numbers and spaces',
    ),

  Loc_Type: Yup.string().required('Location type is required'),
  Type_of_land: Yup.string().required('Type of land is required'),
  // Latitude: Yup.string()
  //   .trim()
  //   .required('Latitude is required')
  //   .max(25, 'Maximum 25 characters allowed'),
  // Longitude: Yup.string()
  //   .trim()
  //   .required('Longitude is required')
  //   .max(25, 'Maximum 25 characters allowed'),
  // Altitude: Yup.string()
  //   .trim()
  //   .required('Altitude is required')
  //   .max(25, 'Maximum 25 characters allowed'),
  Loc_Total_Area: Yup.number()
    .typeError('Total Location area must be a number')
    .required('Total Location area is required')
    // .min(1, 'Total Location area must be greater than or equal to 1')
    .moreThan(0, 'Total Planting area must be greater than 0')
    .max(99999, 'Total Location area must be less than or equal to 99999')
    .test(
      'is-decimal',
      'Total Location area must have up to 2 decimal places',
      (value) => {
        if (value !== undefined) {
          return /^\d+(\.\d{0,2})?$/.test(value.toString());
        }
        return true; // Allow undefined values
      },
    ),
  Total_Ploting_Count: Yup.number()
    .integer('Total Planting Count should not be in decimal')
    .typeError('Total Plotting Count must be a number')
    .required('Total Plotting Count is required')
    .min(1, 'Total Plotting count must be greater than or equal to 1')
    .max(99999, 'Total Planting count must be less than or equal to 99999'),
  //reschedule
});

export const updateInitialValues = {
  Loc_Name: '',
  Loc_Total_Area: '',
  Loc_Type: '',
  Type_of_land: '',
  Latitude: '',
  Longitude: '',
  // Altitude: '',
  Total_Ploting_Count: '',
};
